export default "__VITE_ASSET__Behruplj__"